import { FunctionComponent, useEffect, useRef } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { gutters } from 'Theme/Variables';
import { useLocalization, useResize } from 'Hooks';
import useOnScreen from 'Hooks/useOnScreen';
import { ArrowDownIcon, Checkbox, FormErrorWrapper, FullPageWrapper } from 'Components';
import { agreementsTypes, generateLanguageParam, scrollTop } from 'Utils';
import { formNames } from 'Config';
import { useDispatch, useSelector } from 'react-redux';
import { AccountState, onGetAgreementRequest, setUserAcceptedTicari, storeAccount } from 'Stores/Account';

import '../Signup/SingupConditionsStep/SingupConditionsStep.scss';
import { useHistory } from 'react-router-dom';

type HomeAgreementTicariProps = {};

const HomeAgreementTicari: FunctionComponent<HomeAgreementTicariProps> = ({}) => {
  const {
    web_title_commercial_electronic_communication_permission_text,
    web_btn_next,
    web_btn_scroll,
    web_version_commercial_permission_read_accept,
  } = useLocalization();
  const dispatch = useDispatch();
  const history = useHistory();

  const accountState: AccountState = useSelector(storeAccount);
  const userAccepted = accountState.userAcceptedTicari;
  const { agreementContent } = accountState;

  const containerRef = useRef<any>(null);
  const buttonContainerRef = useRef<HTMLDivElement>(null);

  const { width } = useResize(containerRef);
  const buttonContainerIsVisible = useOnScreen(buttonContainerRef);

  useEffect(() => {
    dispatch(
      onGetAgreementRequest({
        AgreementType: agreementsTypes.TICARI_ELEKTRONIK_ILETISIM_IZNI,
        Language: generateLanguageParam(),
        isSignupProcess: true,
      })
    );
    scrollTop();
  }, []);

  return (
    <FullPageWrapper>
      <div id="signupConditions">
        <div className="signupConditions-container" ref={containerRef}>
          <Typography variant="h5" component="h1" align="center">
            <Box className="signupConditions-title">
              {web_title_commercial_electronic_communication_permission_text}
            </Box>
          </Typography>
          <Box marginBottom={gutters.big}>
            <Typography variant="subtitle2">{agreementContent?.AgreementContent}</Typography>
          </Box>
          <div className="signupConditions-button-container" ref={buttonContainerRef}>
            <FormErrorWrapper formName={formNames.signup} resetFormOnRouteChange>
              <Box className="checkbox-error">
                <Checkbox
                  name="ticariAccepted"
                  color="primary"
                  onClick={() => {
                    dispatch(setUserAcceptedTicari(!userAccepted));
                  }}
                  checked={userAccepted}
                  label={web_version_commercial_permission_read_accept}
                  itemID="signUpTicariConditionsAcceptedInputTest"
                />
              </Box>
              <Button
                onClick={() => {
                  history.goBack();
                }}
                variant="contained"
                color="secondary"
                fullWidth
                type="submit"
                itemID="signUpNextBtnTest"
              >
                {web_btn_next}
              </Button>
            </FormErrorWrapper>
          </div>
          {!buttonContainerIsVisible && (
            <div
              className="signupConditions-dialog"
              style={{
                width: width || 0,
              }}
              onClick={() => buttonContainerRef.current?.scrollIntoView()}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  buttonContainerRef.current?.scrollIntoView();
                }
              }}
            >
              <Typography variant="body2" component="div" className="signupConditions-dialog__inner flexAlignCenter">
                <Box>{web_btn_scroll}</Box>
                <ArrowDownIcon />
              </Typography>
            </div>
          )}
        </div>
      </div>
    </FullPageWrapper>
  );
};

export default HomeAgreementTicari;
